import { depositSlice } from './slices';

export const { setDepositAddress, storeRawDepositData } = depositSlice.actions;
